import { isEmpty } from 'lodash';
import moment from 'moment-timezone';

import { TYPES_MAP } from '@a0/support-center-common/constants/tickets/types';
import severities from '@a0/support-center-common/constants/tickets/customerSelectedSeverities';
import { isTrialTenant } from '@a0/support-center-common/lib/tenants';
import { getAdditionalQuestions } from './utils/fields';
/**
 * Transformation function for deriving a ticket
 * payload from the ticket state in react
 * @param   {Object} ticketState
 * @param   {Object} additionalQuestionState
 * @param   {Object} selectedTenant
 * @returns {Object} ticket
 */
export function ticketPayloadFromState(ticketState, additionalQuestionState, selectedTenant) {
  return {
    ...ticketState,
    comment: resolveComment(ticketState, additionalQuestionState),
    customerSelectedSeverity: resolveSeverity(ticketState, selectedTenant),
    timezone: moment.tz.guess(),
    type: ticketState.type || ''
  };
}

/**
 * Appends additional questions to the ticket comment as a string
 * @param   {Object} ticketState
 * @param   {Object} additionalQuestionState
 * @returns {String} comment
 */
function resolveComment(ticketState, additionalQuestionState) {
  if (isEmpty(additionalQuestionState)) {
    return ticketState.comment;
  }

  const followUpQuestions = getAdditionalQuestions(ticketState);
  if (followUpQuestions.length === 0) {
    return ticketState.comment;
  }
  // Append additionalQuestions to the comment
  const additionalQuestionsString = Object.keys(additionalQuestionState).map(question => {
    const answer = additionalQuestionState[question];
    return `${question}\n${answer || 'Not provided'}`;
  });

  return `${ticketState.comment}\n\n__Additional Data__:\n ${additionalQuestionsString.join('\n\n')}`;
}

/**
 * Sets Severity if appropriate according to pre-determined rules
 * @param   {Object} ticketState
 * @param   {Object} selectedTenant
 * @returns {String} customerSelectedSeverity
 */
function resolveSeverity(ticketState, tenant) {
  if (isTrialTenant(tenant)) {
    return severities.CUSTOMER_SELECTED_SEVERITIES[severities.NORMAL_SEVERITY];
  }

  if (ticketState.customerSelectedSeverity) {
    return ticketState.customerSelectedSeverity;
  }

  // If there is only one specified in the constants, use it
  const ticketTypeDef = TYPES_MAP[ticketState.type];

  const availableSeverities = ticketTypeDef && ticketTypeDef.severities || [];
  if (availableSeverities.length !== 1) {
    return;
  }

  return severities.CUSTOMER_SELECTED_SEVERITIES[availableSeverities[0]];
}

